// extracted by mini-css-extract-plugin
export default {"description":"CreateStudents_description__tn7Ss","numberInput":"CreateStudents_numberInput__lqM4-","fadeIn":"CreateStudents_fadeIn__wUkgv","fadeOut":"CreateStudents_fadeOut__DkrTC"};